module.exports = __webpack_public_path__ + "img/ic-menu-more-open.dd93e15f.svg";